import { render, staticRenderFns } from "./SingleBlock.vue?vue&type=template&id=5aef7e88&scoped=true"
import script from "./SingleBlock.vue?vue&type=script&lang=js"
export * from "./SingleBlock.vue?vue&type=script&lang=js"
import style0 from "./SingleBlock.vue?vue&type=style&index=0&id=5aef7e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aef7e88",
  null
  
)

export default component.exports